import React from "react";
import { TextComponent } from "./TextComponent"; // Adjust the path as necessary
import { FormSectionElements } from "../../entities/formTemplateDataType";
import FormValidationUtils from "../../utilities/FormValidationUtils";

interface Props {
    field: FormSectionElements;
    editable: boolean;
    title;
    labelControlArray;
    requiredField;
    callbackElement;
    isEng: boolean;
  }
  
  interface State {
  
  }

export class NumberComponent extends TextComponent {

  constructor(props: Props) {
    super(props);
  }

  onBlur = (e) => {
    let field = this.props.field;
  
    FormValidationUtils.validateNumber(field);

    if (field.Valid) {
       FormValidationUtils.runJavascript(field);
    }

    this.props.callbackElement(field.parent.parent.parent);
  }
  
  onTextEditChange = (e) => {
    let field = this.props.field;
    let elem = e.originalEvent ? e.originalEvent.target : e.target;
    let val = elem.value;
    field.Value = val;

    FormValidationUtils.runKeyStrokeJavascript(field);

    this.props.callbackElement(this.props.field.parent.parent.parent);
  }
}
